module.exports = __webpack_public_path__ + "img/prizeIcon.d4beb81d.png";